module.exports = __webpack_public_path__ + "img/5.263140fe.png";